/* Sip fixes v2 (9 Oct 2026). File: assets/sip-fixes.js on the draft theme.
   Loaded by one line in the Custom liquid section. Behaviour only, no styling.
   sticky()   sticky add to cart: desktop shows after the main button scrolls past;
              mobile shows whenever the main button is off screen
   labels()   screen-reader "Sale price" / "Regular price" labels the right way round
   prices()   pack rows, main price and sticky price follow One-time / Subscribe
   ship()     delivery bar counts cart + selected pack x quantity against £29
   upsell()   a product never appears in its own "add more" row
   badges()   save badges read "SAVE £X", rounded to the pound, everywhere
              (collection cards, product pages and home page cards)
   oneTime()  collection cards start on One-time purchase (set once, no change event)
   perCan()   "£2.92 per 200ml can" under the main price on the cans page
   eta()      "Order today, delivered by Sun 11 Oct" (today + 3 days) under the delivery bar
   awards()   awards and press line under the stars
   guarantee() Taste Guarantee line under the add to cart button
   desc()     product description under the delivery date (theme block is hidden)
   nutrition() ingredients and nutrition panel under the description
   atcLabel() add to cart reads "Add to cart · £28.99" or "Subscribe · £23.19"
   ctas()     "Choose your pack" buttons after the features, split and FAQ sections
   defaultPack() cans page opens on the 12-pack
   html.sip-c-<collection> class for page-specific styling (bundles page)
   social CTA "Shop what they're drinking" scrolls to the buy box on product pages */
(function () {
  if (window.__sipFix) { return; }
  window.__sipFix = 1;
  document.documentElement.classList.add("sip-js");
  /* Page class for page-specific styling, e.g. html.sip-c-bundles */
  var coll = location.pathname.split("/collections/")[1];
  if (coll) { document.documentElement.classList.add("sip-c-" + coll.split("/")[0]); }

  var T = 2900, d = document, P = null, cart = 0, tm = 0;
  function q(s, r) { return (r || d).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function money(c) { return "£" + (c / 100).toFixed(2); }
  function cents(t) { var m = String(t || "").replace(/,/g, "").match(/\d+(\.\d+)?/); return m ? Math.round(parseFloat(m[0]) * 100) : 0; }
  function setT(e, t) { if (e && e.textContent.trim() !== t) { e.textContent = t; } }

  var parts = location.pathname.split("/products/");
  var handle = parts[1] ? parts[1].split("/")[0] : "";

  function btn() { return q(".product--add-to-cart-button:not(.custom-upcell-atc-btn)"); }
  function box() { var b = btn(); return b ? (b.closest(".product-form-wrapper") || b.closest("form")) : null; }
  function plan() { var r = q("input[name=selling_plan]:checked"); return r ? r.value : ""; }
  var XEND = Date.UTC(2026, 11, 20, 23, 59, 59), XDEAL = { "SIP0028": 1000, "SIP0020": 1000, "SIP0018": 1000, "SIP-MIX-700-6": 1500, "SIP-MILA-700-6": 1500, "SIP-CECE-700-6": 1500 }; function sipDeal(v) { return (Date.now() < XEND && v && XDEAL[v.sku]) ? XDEAL[v.sku] : 0; } function vprice(id) {
    if (!P) { return null; }
    var v = null, i, a, pl = plan();
    for (i = 0; i < P.variants.length; i++) { if (String(P.variants[i].id) === String(id)) { v = P.variants[i]; } }
    if (!v) { return null; }
    if (pl) {
      a = v.selling_plan_allocations || [];
      for (i = 0; i < a.length; i++) { if (String(a[i].selling_plan_id) === pl) { return a[i].price; } }
    }
    return v.price - sipDeal(v);
  }
  function curId() { var b = btn(), f = b ? b.closest("form") : null, i = f ? q("[name=id]", f) : null; return i ? i.value : ""; }

  function sticky() {
    var s = q("sticky-add-to-cart"), b = btn();
    if (!s) { return; }
    if (!b) { s.classList.add("sip-on"); return; }
    var r = b.getBoundingClientRect(), mobile = window.innerWidth < 750;
    var on = mobile ? (r.top > window.innerHeight || r.bottom < 0) : r.bottom < 0;
    s.classList.toggle("sip-on", on);
  }

  function labels() {
    qa(".product-price-group").forEach(function (g) {
      var c = q(".compare-at-price.on-sale", g), p = q("[data-product-price]", g);
      if (!c || !p) { return; }
      [[p, "Sale price"], [c, "Regular price"]].forEach(function (x) {
        var s = x[0].previousElementSibling;
        if (s && s.classList.contains("visually-hidden")) { setT(s, x[1]); }
      });
    });
  }

  function prices() {
    if (!P) { return; }
    qa(".pack-swatch-item").forEach(function (it) {
      var c = vprice(it.getAttribute("data-swatch-variant-id"));
      if (c !== null) { setT(q(".pack-swatch-price", it), money(c)); }
    });
    var c = vprice(curId());
    if (c !== null) {
      qa(".custom-product-price-group [data-price-text],.sticky-add-to-cart__price [data-price-text]").forEach(function (e) { setT(e, money(c)); });
    }
  }

  function ship() {
    var bar = q(".product-form-block .cart-drawer__free-shipping-message");
    if (!bar || !P) { return; }
    var c = vprice(curId());
    if (c === null) { return; }
    var bx = box(), qi = bx ? q("input[name=quantity]", bx) : null, n = qi ? parseInt(qi.value, 10) || 1 : 1;
    var tot = cart + c * n, rem = T - tot;
    var p = q("[data-free-shipping-text]", bar), r = q("[data-free-shipping-remaining-right]", bar), fill = q("[data-free-shipping-fill]", bar);
    if (!p) { return; }
    if (!bar.__o && q("[data-free-shipping-remaining]", p)) { bar.__o = p.innerHTML; }
    if (rem <= 0) {
      setT(p, "Free UK delivery included");
      setT(r, "");
    } else if (handle === "bottles" && cart === 0) { setT(p, "Add a second bottle for free UK delivery"); setT(r, ""); } else if (handle === "sip-multipacks" && cart === 0) {
      setT(p, "Choose the 12-pack for free UK delivery");
      setT(r, "");
    } else {
      if (!q("[data-free-shipping-remaining]", p) && bar.__o) { p.innerHTML = bar.__o; }
      setT(q("[data-free-shipping-remaining]", p), money(rem));
      setT(r, money(rem));
    }
    if (fill) { var w = Math.min(100, Math.round(tot / T * 100)) + "%"; if (fill.style.width !== w) { fill.style.width = w; } }
  }

  function upsell() {
    if (!handle) { return; }
    qa(".custom-product-item").forEach(function (it) {
      var a = q("a", it), h = a ? (a.getAttribute("href") || "") : "";
      if (h.indexOf("/products/") > -1 && h.split("/products/")[1].split(/[?#\/]/)[0] === handle) { it.style.display = "none"; }
    });
  }

  function badges() {
    qa(".grid-view-item").forEach(function (c) {
      var b = q(".plp-card-discount-badge", c), a = q(".price-line-through", c), s = q(".price--sale-price", c);
      if (b && a && s) { var x = cents(a.textContent) - cents(s.textContent); if (x > 0) { setT(b, "SAVE £" + Math.round(x / 100)); } }
    });
    qa(".price-save-badge").forEach(function (b) {
      var g = b.closest(".product-price-group"), a = g ? q(".compare-at-price .money", g) : null, s = g ? q("[data-product-price] .money", g) : null;
      if (a && s) { var x = cents(a.textContent) - cents(s.textContent); if (x > 0) { setT(b, "SAVE £" + Math.round(x / 100)); } }
    });
    /* Home page cards: "SAVE £X" instead of the section's own "SAVE 26%".
       Only the text is changed, so the dot inside the badge stays. */
    qa(".mi-card").forEach(function (c) {
      var b = q(".mi-save-badge", c), a = q(".mi-compare-price", c), s = q(".mi-current-price", c);
      if (!b || !a || !s) { return; }
      var x = cents(a.textContent) - cents(s.textContent);
      if (x <= 0) { return; }
      var t = "SAVE £" + Math.round(x / 100), n = b.lastChild;
      if (!n || n.nodeType !== 3) { n = d.createTextNode(""); b.appendChild(n); }
      if (n.nodeValue.trim() !== t) { n.nodeValue = " " + t; }
    });
  }

  /* Collection cards: tick One-time purchase once, quietly. No change event:
     the card widget answers a change event by clearing the radios, which looped. */
  function oneTime() {
    qa(".subscription-widget__purchase-type").forEach(function (w) {
      if (w.__sip || q("input:checked", w)) { return; }
      w.__sip = 1;
      var r = qa("input[type=radio]", w).filter(function (x) { return x.value === "one_time"; })[0];
      if (r) { r.checked = true; }
    });
  }

  /* Per-can price under the main price (cans page), from the selected pack row */
  function perCan() {
    var g = q(".custom-product-price-group");
    if (!g) { return; }
    var it = qa(".pack-swatch-item").filter(function (x) { var i = q("input", x); return i && i.checked; })[0];
    var t = it ? q(".pack-price-line-text", it) : null;
    var s = q(".sip-percan", g);
    if (!t || !t.textContent.trim()) { if (s) { s.remove(); } return; }
    if (!s) { s = d.createElement("span"); s.className = "sip-percan"; g.appendChild(s); }
    setT(s, t.textContent.trim().replace(/per can/i, "per 200ml can"));
  }

  /* Delivery date under the delivery bar: today + 3 days (warehouse works 7 days) */
  function eta() {
    var bx = box();
    if (!bx || q(".sip-eta", d)) { return; }
    var bar = q(".product-form-block .cart-drawer__free-shipping-message");
    var dt = new Date();
    dt.setDate(dt.getDate() + 2);
    var e = d.createElement("p"); e.className = "sip-eta";
    e.textContent = "Order today, delivered by " + dt.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
    if (bar) { bar.parentNode.insertBefore(e, bar.nextSibling); }
    else { var b = btn(); if (b && b.parentNode) { b.parentNode.parentNode.insertBefore(e, b.parentNode.nextSibling); } }
  }

  /* Awards and press under the stars */
  function awards() {
    var bx = box();
    if (!bx || q(".sip-awards", d)) { return; }
    var r = q(".custom-product-details-wrapper .product-rating-custom");
    var blk = r ? (r.closest(".product-form-block") || r) : null;
    if (!blk) { return; }
    var e = d.createElement("p"); e.className = "sip-awards";
    e.innerHTML = "<span>Great Taste 2-star, IWSC Bronze, World Alcohol-Free Silver</span><span>As featured in Vogue, Vanity Fair and Tatler</span>";
    blk.parentNode.insertBefore(e, blk.nextSibling);
  }

  /* Taste Guarantee line directly under the add to cart button */
  function guarantee() {
    var b = btn();
    if (!b || q(".sip-guarantee", d)) { return; }
    var blk = b.closest(".custom-buy-button-margin") || b.closest(".product-form-block");
    if (!blk) { return; }
    var e = d.createElement("p"); e.className = "sip-guarantee";
    e.innerHTML = 'Love it or your first pack is on us. <a href="/pages/taste-guarantee">Terms apply.</a>';
    blk.parentNode.insertBefore(e, blk.nextSibling);
  }

  /* Product description (what's inside, which pack) under the delivery date.
     Shown by the script because the theme's description block is hidden on the draft.
     If that block is switched back on in the editor, the script steps aside. */
  function desc() {
    var bx = box();
    if (!bx || !P || !P.description || q(".sip-desc", d)) { return; }
    var own = q(".custom-product-details-wrapper .product-description");
    if (own && own.offsetHeight > 0 && own.textContent.trim()) { return; }
    var after = q(".sip-eta") || q(".product-form-block .cart-drawer__free-shipping-message");
    var blk = after ? (after.closest(".product-form-block") || after) : null;
    if (!blk) { return; }
    var e = d.createElement("div"); e.className = "sip-desc rte";
    e.innerHTML = P.description.replace(/<meta[^>]*>/gi, "");
    blk.parentNode.insertBefore(e, blk.nextSibling);
  }

  /* Ingredients and nutrition, same for cans and bottles, under the description */
  var NUT = [
    ["Mila: Margarita", "Water, Vegetable Glycerine, Lime Juice (not from concentrate), Agave Syrup, Natural Flavourings, Lime Flower Extract, Grapefruit Extract, Salt, Jalape\u00f1o Extract.",
     [["Energy", "234kJ / 56kcal", "469kJ / 112kcal"], ["Fat", "0g", "0g"], ["of which saturates", "0g", "0g", 1], ["Carbohydrate", "13.8g", "27.6g"], ["of which sugars", "3.6g", "7.1g", 1], ["Fibre", "<0.5g", "0.6g"], ["Protein", "<0.5g", "<0.5g"], ["Salt", "0.04g", "0.08g"]]],
    ["Cece: Negroni", "Water, Vegetable Glycerine, White Grape Juice from Concentrate, Orange Juice from Concentrate, Lime Juice, Natural Flavourings, Gentian Root Extract, Juniper Extract, Orris Root Extract, Black Carrot Concentrate, Carthamus Concentrate.",
     [["Energy", "209kJ / 50kcal", "418kJ / 100kcal"], ["Fat", "<0.5g", "<0.5g"], ["of which saturates", "<0.1g", "<0.1g", 1], ["Carbohydrate", "12.2g", "24.5g"], ["of which sugars", "2.1g", "4.3g", 1], ["Fibre", "<0.5g", "<0.5g"], ["Protein", "<0.5g", "<0.5g"], ["Salt", "<0.01g", "<0.01g"]]]
  ];
  function esc(t) { return String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;"); }
  function nutrition() {
    var bx = box();
    if (!bx || q(".sip-nutri", d)) { return; }
    var after = q(".sip-desc") || q(".sip-eta") || q(".product-form-block .cart-drawer__free-shipping-message");
    var blk = after ? (after.classList.contains("sip-desc") ? after : (after.closest(".product-form-block") || after)) : null;
    if (!blk) { return; }
    var h = '<summary>Ingredients &amp; nutrition</summary><div class="sip-nutri__in">';
    NUT.forEach(function (f) {
      h += "<h4>" + esc(f[0]) + "</h4><p>" + esc(f[1]) + '</p><table><tr><th></th><th>Per 100ml</th><th>Per 200ml serving</th></tr>';
      f[2].forEach(function (r) { h += "<tr" + (r[3] ? ' class="sub"' : "") + "><td>" + esc(r[0]) + "</td><td>" + esc(r[1]) + "</td><td>" + esc(r[2]) + "</td></tr>"; });
      h += "</table>";
    });
    h += "<p>Alcohol free, under 0.2% ABV. Cans are 200ml. Bottles are 700ml (4 serves).</p></div>";
    var e = d.createElement("details"); e.className = "sip-nutri"; e.innerHTML = h;
    blk.parentNode.insertBefore(e, blk.nextSibling);
  }

  /* Add to cart button says what will happen: "Add to cart · £28.99" or "Subscribe · £23.19" */
  function atcLabel() {
    var b = btn();
    if (!b || b.disabled || !P) { return; }
    var span = qa("span", b).filter(function (x) { return !/loading/i.test(x.className + x.textContent); })[0];
    var c = vprice(curId());
    if (!span || c === null) { return; }
    setT(span, (plan() ? "Subscribe · " : "Add to cart · ") + money(c));
  }

  /* "Choose your pack" buttons lower down product pages, scrolling back to the buy box */
  function ctas() {
    var bx = box();
    if (!bx || !P) { return; }
    var label = P.variants.length > 1 ? "Choose your pack" : "Add to cart";
    [".custom-features-wrapper", ".cus-split-wrapper", ".cus-faq-wrapper"].forEach(function (sel) {
      var w = q(sel);
      if (!w || q(".sip-cta-wrap", w)) { return; }
      var wrap = d.createElement("div"); wrap.className = "sip-cta-wrap";
      var a = d.createElement("button"); a.type = "button"; a.className = "sip-scroll-cta"; a.textContent = label;
      a.addEventListener("click", function () { window.scrollTo({ top: box().getBoundingClientRect().top + window.pageYOffset - 90, behavior: "smooth" }); });
      wrap.appendChild(a); w.appendChild(wrap);
    });
  }

  /* Cans page opens on the 12-pack (most popular) unless a pack is in the link */
  var packSet = false;
  function defaultPack() {
    if (packSet || handle !== "sip-multipacks" || /[?&]variant=/.test(location.search)) { return; }
    var items = qa(".pack-swatch-item");
    if (!items.length) { return; }
    packSet = true;
    var it = items.filter(function (x) { var t = q(".pack-swatch-title", x); return t && /\b12\b/.test(t.textContent); })[0];
    if (!it) { return; }
    var i = q("input", it);
    if (i && !i.checked) { (q("label", it) || i).click(); }
  }

  function run() { defaultPack(); labels(); prices(); ship(); upsell(); badges(); oneTime(); perCan(); eta(); awards(); guarantee(); desc(); nutrition(); atcLabel(); ctas(); sticky(); }
  function later() { clearTimeout(tm); tm = setTimeout(run, 60); }
  function getCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { cart = c.total_price; later(); }).catch(function () {});
  }

  d.addEventListener("change", function () { later(); setTimeout(run, 400); }, true);
  d.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target.closest(".sip-social-feed__cta-link") : null, bx = box();
    if (t && bx) {
      e.preventDefault();
      window.scrollTo({ top: bx.getBoundingClientRect().top + window.pageYOffset - 90, behavior: "smooth" });
      return;
    }
    setTimeout(run, 400);
    if (e.target.closest && e.target.closest("[name=add],[class*=cart],[class*=quantity]")) { setTimeout(getCart, 1500); }
  }, true);
  window.addEventListener("scroll", sticky, { passive: true });
  window.addEventListener("resize", sticky);
  d.addEventListener("theme:cartchanged", getCart);

  function init() {
    run();
    getCart();
    /* Apps and card widgets render after page load: run again once they exist */
    setTimeout(run, 1000);
    setTimeout(run, 3000);
    if (window.MutationObserver) {
      var ob = q(".product-form-wrapper") || q("main") || d.body;
      if (ob) { new MutationObserver(later).observe(ob, { childList: true, subtree: true, characterData: true }); }
    }
    if (handle) {
      fetch("/products/" + handle + ".js").then(function (r) { return r.json(); }).then(function (p) { P = p; run(); }).catch(function () {});
    }
  }
  if (d.readyState === "loading") { d.addEventListener("DOMContentLoaded", init); } else { init(); }
})();/* 13 Oct: home bundle cards show "£94.99", not "From£94.99" */
(function () {
  function noFrom() {
    document.querySelectorAll(".format-collection__price").forEach(function (p) {
      var t = p.textContent.replace(/from\s*/i, "").trim();
      if (p.textContent.trim() !== t) { p.textContent = t; }
    });
  }
  noFrom();
  document.addEventListener("DOMContentLoaded", noFrom);
  setTimeout(noFrom, 1500);
})();
/* Sip per-can price fix (25 Oct 2026). Paste at the very END of assets/sip-fixes.js.
The theme's pack-price-calculator worked out per-can prices from the price the
subscription widget was showing. While the page loads, that widget can still be
showing another pack's price, so wrong per-can prices flashed up.
This works them out from the product's own prices instead:
pack price (one-time or subscription) divided by cans in the pack. */
(function () {
var C = window.customElements && customElements.get("pack-price-calculator");
if (!C || C.__sip) { return; }
C.__sip = 1;
var P = null;
var h = (location.pathname.split("/products/")[1] || "").split("/")[0];
function plan() { var r = document.querySelector("input[name=selling_plan]:checked"); return r ? r.value : ""; }
function price(id, oneTime) {
var pl = plan();
if (!pl) { return oneTime; }
if (!P) { return null; }
var i, v = null, a;
for (i = 0; i < P.variants.length; i++) { if (String(P.variants[i].id) === String(id)) { v = P.variants[i]; } }
if (!v) { return null; }
a = v.selling_plan_allocations || [];
for (i = 0; i < a.length; i++) { if (String(a[i].selling_plan_id) === pl) { return a[i].price; } }
return v.price;
}
function fix(el) {
var t = el.querySelector("[data-pack-price-text]");
var m = (el.variantMap || {})[el.variantId];
if (!t || !m || !m.qty || !m.price) { return; }
var c = price(el.variantId, m.price);
if (c === null) { return; }
function xd(v) { var on = Date.now() < Date.UTC(2026, 11, 20, 23, 59, 59) && v; if (on && /^(SIP0028|SIP0020|SIP0018)$/.test(v.sku || "")) { return 1000; } if (on && /-700-6$/.test(v.sku || "")) { return 1500; } return 0; } function lbl(el2, cc) { var it = el2.closest(".pack-swatch-item"); function num(x) { var tt = x.querySelector(".pack-swatch-title"), mm = tt ? tt.textContent.match(/\d+/) : null; return mm ? parseInt(mm[0], 10) : 0; } var ns = Array.prototype.slice.call(document.querySelectorAll(".pack-swatch-item")).map(num).filter(Boolean); var n = it ? num(it) : 0, bottle = /bottle/i.test(el2.unitLabel || ""); if (!n || ns.length < 2) { return "£" + (cc / 100 / (m.qty || 1)).toFixed(2) + " per " + (el2.unitLabel || "can"); } var sv = bottle ? n * 4 : n; if (n === Math.max.apply(null, ns)) { return "£" + (cc / 100 / sv).toFixed(2) + (bottle ? " a serve" : " per can"); } if (n === Math.min.apply(null, ns)) { return "Try it first"; } return sv + (bottle ? " serves" : " cocktails"); } if (!plan() && P) { P.variants.forEach(function (x) { if (String(x.id) === String(el.variantId)) { c -= xd(x); } }); } var s = lbl(el, c);
if (t.textContent !== s) { t.textContent = s; }
}
function all() { document.querySelectorAll("pack-price-calculator").forEach(fix); }
C.prototype.update = function () { fix(this); };
C.prototype.renderFromCache = function () { fix(this); };
all();
if (h) {
fetch("/products/" + h + ".js").then(function (r) { return r.json(); }).then(function (p) { P = p; all(); }).catch(function () {});
}
document.addEventListener("change", function () { setTimeout(all, 50); }, true);
})();

/* Sip subscribe tick box (25 Oct 2026) */
(function () {
if (window.__sipSubToggle) { return; }
window.__sipSubToggle = 1;
var was = false;
document.addEventListener("pointerdown", function (e) {
var o = e.target.closest && e.target.closest(".appstle_subscription_wrapper_option");
if (!o) { return; }
var i = o.querySelector("input[name=selling_plan]");
was = !!(i && i.value && i.checked);
}, true);
document.addEventListener("click", function (e) {
if (!e.isTrusted || !was) { return; }
var o = e.target.closest && e.target.closest(".appstle_subscription_wrapper_option");
if (!o || e.target.closest("select,.appstle_subscribe_option")) { return; }
was = false;
setTimeout(function () {
var one = document.querySelector("input[name=selling_plan][value='']");
if (one) { one.click(); }
}, 50);
}, true);
})();
/* Home "Shop the bundles" cards: "£94.99" instead of "From£94.99" */
(function () {
  function noFrom() {
    document.querySelectorAll(".format-collection__price").forEach(function (p) {
      var t = p.textContent.replace(/from\s*/i, "").trim();
      if (p.textContent.trim() !== t) { p.textContent = t; }
    });
  }
  noFrom();
  document.addEventListener("DOMContentLoaded", noFrom);
  setTimeout(noFrom, 1500);
})();
/* Repeat-deliveries box prices (3 Nov 2026).
   When the cans page opens on the 12-pack, the Appstle box kept the 8-pack prices.
   This sets the box's one-time and subscription prices from the selected pack. */
(function () {
  var h = (location.pathname.split("/products/")[1] || "").split("/")[0];
  if (!h) { return; }
  var P = null, d = document, tm = 0;
  function m(c) { return "£" + (c / 100).toFixed(2); }
  function st(e, t) { if (e.textContent.trim() !== t) { e.textContent = t; } }
  function fix() {
    if (!P) { return; }
    var b = d.querySelector(".product--add-to-cart-button:not(.custom-upcell-atc-btn)");
    var f = b ? b.closest("form") : null, i = f ? f.querySelector("[name=id]") : null;
    var v = null;
    if (i) { P.variants.forEach(function (x) { if (String(x.id) === String(i.value)) { v = x; } }); }
    if (!v) { return; }
    d.querySelectorAll(".appstle_subscription_wrapper_option").forEach(function (o) {
      var r = o.querySelector("input[name=selling_plan]"), pl = r ? r.value : "";
      if (!pl) { var s = o.querySelector("select"); if (s && s.value) { pl = s.value; } }
      var c = v.price, a = v.selling_plan_allocations || [], k;
      if (pl) { for (k = 0; k < a.length; k++) { if (String(a[k].selling_plan_id) === String(pl)) { c = a[k].price; } } if (c === v.price && a[0]) { c = a[0].price; } }
      o.querySelectorAll(".appstle_subscription_amount").forEach(function (e) { st(e, m(c)); });
      o.querySelectorAll(".appstle_subscription_amount-appstle-sr-only").forEach(function (e) { st(e, (pl ? "Sale price " : "Regular price ") + m(c)); });
      o.querySelectorAll(".appstle_subscription_compare_amount").forEach(function (e) { st(e, m(v.price)); });
      o.querySelectorAll(".appstle_subscription_compare_amount-appstle-sr-only").forEach(function (e) { st(e, "Regular price " + m(v.price)); });
    });
  }
  function later() { clearTimeout(tm); tm = setTimeout(fix, 80); }
  fetch("/products/" + h + ".js").then(function (r) { return r.json(); }).then(function (p) { P = p; fix(); }).catch(function () {});
  d.addEventListener("change", function () { setTimeout(fix, 300); setTimeout(fix, 900); }, true);
  d.addEventListener("click", function () { setTimeout(fix, 400); }, true);
  if (window.MutationObserver) { new MutationObserver(later).observe(d.body, { childList: true, subtree: true, characterData: true }); }
  setTimeout(fix, 1500);
  setTimeout(fix, 3500);
})();

/* Christmas stock-up display (3 Nov - 20 Dec 2026).
   The saving itself is two Shopify automatic discounts: £10 off 24-packs and £15 off 6 bottles,
   one-time orders only. This shows the struck full price and a red line on those pack tiles,
   and rewords the cart drawer upgrade box. Turns itself off after 20 Dec. */
(function () {
  var END = Date.UTC(2026, 11, 20, 23, 59, 59);
  var d = document, P = null, tm = 0;
  var h = (location.pathname.split("/products/")[1] || "").split("/")[0];
  function off(v) {
    if (!v || Date.now() >= END) { return 0; }
    if (/^(SIP0028|SIP0020|SIP0018)$/.test(v.sku || "")) { return 1000; }
    if (/-700-6$/.test(v.sku || "")) { return 1500; }
    return 0;
  }
  function sub() { var r = d.querySelector("input[name=selling_plan]:checked"); return !!(r && r.value); }
  function txt(e, t) { if (e && e.textContent.trim() !== t) { e.textContent = t; } }
  function tiles() {
    if (!P) { return; }
    var s = sub();
    d.querySelectorAll(".pack-swatch-item").forEach(function (it) {
      var id = it.getAttribute("data-swatch-variant-id"), v = null;
      P.variants.forEach(function (x) { if (String(x.id) === String(id)) { v = x; } });
      var o = s ? 0 : off(v), pr = it.querySelector(".pack-swatch-price"), was = it.querySelector(".sip-was"), b = it.querySelector(".sip-xmas");
      if (o && pr) {
        if (!was) { was = d.createElement("s"); was.className = "sip-was"; pr.parentNode.insertBefore(was, pr.nextSibling); }
        txt(was, "£" + (v.price / 100).toFixed(2));
        var bd = it.querySelector(".pack-swatch-badge"); if (bd) { if (!bd.getAttribute("data-sip-o")) { bd.setAttribute("data-sip-o", bd.textContent.trim()); } if (b) { b.remove(); } b = bd; } else if (!b) { b = d.createElement("span"); b.className = "sip-xmas"; (it.querySelector(".pack-swatch-price-col") || it).appendChild(b); }
        txt(b, "Christmas · save £" + (o / 100));
      } else {
        if (was) { was.remove(); }
        if (b) { b.remove(); } var bo = it.querySelector(".pack-swatch-badge[data-sip-o]"); if (bo) { txt(bo, bo.getAttribute("data-sip-o")); bo.removeAttribute("data-sip-o"); }
      }
    });
  }
  function drawer() { if (Date.now() >= END) { d.querySelectorAll(".announcement-item").forEach(function (e) { if (/Christmas stock-up/i.test(e.textContent)) { e.style.display = "none"; } }); }
    if (Date.now() >= END) { return; }
    d.querySelectorAll(".cart-drawer__upsell-subtitle").forEach(function (e) { txt(e, "Bigger pack, better value."); });
  }
  /* Pack tiles load built for the first flavour (Mixed has no single bottle), so match each tile to the chosen flavour (3 Nov) */ function remap() { if (!P) { return; } var f = d.querySelector('input[name^="option-1"]:checked'); if (!f) { return; } d.querySelectorAll(".pack-swatch-item").forEach(function (it) { var val = it.getAttribute("data-value"), v = null; P.variants.forEach(function (x) { if (x.option1 === f.value && x.option2 === val) { v = x; } }); if (!v || it.getAttribute("data-swatch-variant-id") === String(v.id)) { return; } it.setAttribute("data-swatch-variant-id", v.id); it.setAttribute("data-swatch-option-available", String(v.available)); it.classList.toggle("soldout", !v.available); var i = it.querySelector("input"); if (i) { i.setAttribute("data-product-variant", v.id); } }); } function run() { try { remap(); tiles(); drawer(); } catch (e) {} }
  function later() { clearTimeout(tm); tm = setTimeout(run, 100); }
  if (window.MutationObserver) { new MutationObserver(later).observe(d.body, { childList: true, subtree: true, characterData: true }); }
  d.addEventListener("change", function () { setTimeout(run, 400); }, true);
  if (h) { fetch("/products/" + h + ".js").then(function (r) { return r.json(); }).then(function (p) { P = p; run(); }).catch(function () {}); }
  run();
  setTimeout(run, 1500);
})();

/* Gift and guarantee above the fold (3 Nov 2026).
   Product pages: red "gift ready" badge on the main photo, and a gift + Taste Guarantee box under the ticks.
   The same two lines lower down (under add to cart) are hidden while the box shows. */
(function () {
  var d = document;
  var GIFT = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
  var TICK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var st = d.createElement("style");
  st.textContent =
    ".sip-promise{margin:16px 0 24px;padding:10px 14px;background:#FDEDEB;border-radius:12px;display:grid;gap:6px}" +
    ".sip-promise p{margin:0!important;display:flex;align-items:center;gap:8px;font:700 14px/1.35 'Barlow',sans-serif;color:#204222}" +
    ".sip-promise svg{flex:0 0 16px;color:#DE323E}" +
    ".sip-promise a{color:inherit!important;font-weight:500;text-decoration:underline!important}" +
    "html.sip-promise-on .sipc-gift,html.sip-promise-on .sip-guarantee{display:none!important}" +
    ".sip-gift-badge{position:absolute;left:14px;top:12px;z-index:5;display:inline-flex;align-items:center;gap:8px;padding:9px 16px;border-radius:999px;background:#DE323E;color:#F5F0E8;font:700 13px/1.2 'Barlow',sans-serif;letter-spacing:.3px;box-shadow:0 4px 14px rgba(0,0,0,.15);pointer-events:none}" +
    "@media(max-width:749px){.sip-gift-badge{left:12px;top:12px;padding:7px 12px;font-size:12px}}";
  d.head.appendChild(st);
  function run() {
    var ft = d.querySelector(".custom-product-details-wrapper .custom-features-block");
    if (ft && !d.querySelector(".sip-promise")) {
      var box = d.createElement("div");
      box.className = "sip-promise";
      box.innerHTML = "<p>" + GIFT + "<span>Sending it as a gift? Add a free gift message in your cart.</span></p>" +
        "<p>" + TICK + '<span>Love it or your first pack is on us. <a href="/pages/taste-guarantee">Terms apply.</a></span></p>';
      ft.parentNode.insertBefore(box, ft.nextSibling);
      d.documentElement.classList.add("sip-promise-on");
    }
    var sl = d.querySelector(".product-media-slider-main");
    if (sl && !sl.querySelector(".sip-gift-badge")) {
      var b = d.createElement("span");
      b.className = "sip-gift-badge";
      b.innerHTML = GIFT + "<span>Free gift message</span>";
      sl.appendChild(b);
    }
  }
  if (!/\/products\//.test(location.pathname)) { return; }
  if (d.readyState === "loading") { d.addEventListener("DOMContentLoaded", run); } else { run(); }
  setTimeout(run, 1000);
  setTimeout(run, 3000);
})();
